import React, { useEffect, useState } from "react";
import { Switch, withRouter } from "react-router-dom";
import { customTheme } from "../muiTheme";
import useStyles from "../styles";
import { useLayoutState } from "../../../context/LayoutContext";
import { useTheme } from "@material-ui/styles";
import classNames from "classnames";
import CloseIcon from "@material-ui/icons/Close";
import { ToastContainer } from "react-toastify";
import { MuiThemeProvider } from "@material-ui/core/styles";
import EmployeeRoutes from "./EmployeeRoutes";
import EmployeeHeader from "../../Header/EmployeeHeader";
import EmpSidebar from "../../Sidebar/EmpSidebar";

// Import other role-based route files

const EmployeeRouter = (props) => {
  const classes = useStyles();
  const theme = useTheme();

  const layoutState = useLayoutState();


  var [isPermanent, setPermanent] = useState(true);

  useEffect(function () {
    window.addEventListener("resize", handleWindowWidthChange);
    handleWindowWidthChange();
    return function cleanup() {
      window.removeEventListener("resize", handleWindowWidthChange);
    };
  });

  function handleWindowWidthChange() {
    var windowWidth = window.innerWidth;
    var breakpointWidth = theme.breakpoints.values.sm;
    var isSmallScreen = windowWidth < breakpointWidth;
    if (isSmallScreen && isPermanent) {
      setPermanent(false);
    } else if (!isSmallScreen && !isPermanent) {
      setPermanent(true);
    }
  }

  return (
    <div className={classes.root}>
      <MuiThemeProvider theme={customTheme}>
        <EmpSidebar />
        <div
          className={classNames(classes.content, {
            [classes.contentShift]: isPermanent && !layoutState.isSidebarOpened,
            [classes.contentShift1]: layoutState.isSidebarOpened,
          })}
        >
          {/* <UserDataProvider> */}
            <div className={classes.fakeToolbar}>
              <EmployeeHeader history={props.history} />
            </div>
          {/* </UserDataProvider> */}
          <Switch>
            <EmployeeRoutes role={"EMPLOYEE"} />
            {/* Add other role-based route conditions */}
          </Switch>
        </div>
        <ToastContainer
          closeButton={
            <CloseButton className={classes.notificationCloseButton} />
          }
          closeOnClick={false}
          hideProgressBar={true}
        />
      </MuiThemeProvider>
    </div>
  );
};

function CloseButton({ closeToast, className }) {
  return <CloseIcon className={className} onClick={closeToast} />;
}

// function renderRoutesBasedOnCompanyType(companyType, role) {
//     if (companyType === "COMPANY") {
//         return (
//             <>
//                 <AuthRoute path="/app/projects" role={role} roles={["ADMIN", "CLIENTCOORDINATOR"]} component={Projects} />
//                 <AuthRoute path="/app/reports/vendor_onboarded_candidates" role={role} roles={["ADMIN"]} component={AllInvoiced} />
//             </>
//         );
//     }
//     else {
//         return (
//             <>
//                 <AuthRoute path="/app/clients" role={role} roles={["ADMIN"]} component={Clients} />
//                 <AuthRoute path="/app/resume_search" role={role} roles={["ADMIN"]} component={ResumeSearch} />
//                 {/* Reports */}
//                 <AuthRoute path="/app/reports/all_candidates_invoiced" role={role} roles={["ADMIN"]} component={AllInvoiced} />
//             </>
//         )
//     }
// }

export default withRouter(EmployeeRouter);
